module.exports = __webpack_public_path__ + "media/images/sp-side-ad@2x-57b113f5def26e56b239648abe79e9e5.png";